import type { LucideProps } from "lucide-react";
import { X } from "lucide-react";

export type ErrorIconProps = LucideProps;

export const ErrorIcon = (props: ErrorIconProps) => <X {...props} />;

export default ErrorIcon;
